import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=4fbca2b6&scoped=true&"
import script from "./ReportHeader.vue?vue&type=script&lang=js&"
export * from "./ReportHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbca2b6",
  null
  
)

export default component.exports